import React, { useState } from "react";
import QRCode from "react-qr-code";
import { CiShare2 } from "react-icons/ci";
import { CopyAllOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import CommonModal from "./CommonModal";

const ShareModal = ({ shareableLink, onClose }) => {
  console.log("shara", shareableLink);
  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareableLink);
  };

  return (
    <>
      <CommonModal heading="Share Draft" onClose={onClose}>
        <div className="w-full flex flex-col items-center gap-6">
          <div className="bg-white p-4 rounded-lg">
            <QRCode value={shareableLink} size={200} />
          </div>
          <div className="flex items-center gap-2 w-full">
            <input
              className="flex-1 px-3 py-2 border rounded-md text-sm bg-white"
              value={shareableLink}
              readOnly
            />
            <Button
              variant="outlined"
              size="small"
              onClick={handleCopyLink}
              sx={{
                minWidth: "36px",
                width: "36px",
                height: "36px",
                padding: "4px",
              }}
            >
              <CopyAllOutlined className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default ShareModal;
